import { SimpleChange } from '@angular/core';

export const isEquivalent = <T>(a: T, b: T): boolean => {
  if (Array.isArray(a) && Array.isArray(b)) {
    // deep compare arrays
    return JSON.stringify(a) === JSON.stringify(b);
  }
  // compare dates, ignoring time
  if (a instanceof Date && b instanceof Date) {
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }
  // deep compare objects
  if (typeof a === 'object' && typeof b === 'object') {
    return JSON.stringify(a) === JSON.stringify(b);
  }
  // shallow compare
  return a === b;
};

export const hasChanged = (values: SimpleChange[]): boolean => {
  return values.some(
    (value: SimpleChange) =>
      !isEquivalent(value?.currentValue, value?.previousValue)
  );
};
